import React from 'react';
import styled from '../../../components/styled';
import { useFormikContext } from 'formik';

import { RichTextField } from '../../../components';

interface CommentSnippetProps {
  path: string;
  rowData: string;
}

const CommentSnippet = ({ path, rowData }: CommentSnippetProps) => {
  const { handleChange } = useFormikContext();

  return (
    <TextInput
      placeholder="Please enter any comments"
      value={rowData}
      onChangeText={handleChange(path)}
    />
  );
};

const TextInput = styled(RichTextField)`
  min-height: 100px;
  margin: 0px 12px 5px;
`;

export default CommentSnippet;
